import { useState } from 'react';

import { useSelector } from 'react-redux';

import { useBillingState } from '@/modules/billing/hooks/useBillingState';
import {
  createSimulationUrl,
  simulationsListPath,
  stashCreateRequest,
} from '@/modules/simulations/navigation';
import { stringifyStartingContext } from '@/modules/simulations/startingContext';
import { selectAccountSlug } from '@/redux/session/selectors';

import { selectBrainId, selectMessages, selectSimulationContext } from '../redux/selectors';
import { toContextVariables } from '../utils/contextVariablesJson';
import { transcriptForDraft } from '../utils/transcript';

type CreateSimulationLink = { href: string; stash: () => void };

export const useCreateSimulationLink = (): CreateSimulationLink | null => {
  const slug = useSelector(selectAccountSlug);
  const brainId = useSelector(selectBrainId);
  const context = useSelector(selectSimulationContext);
  const messages = useSelector(selectMessages);
  const [requestId] = useState(() => crypto.randomUUID());
  const isTrial = useBillingState()?.plan_type === 'trial';

  const stash = () =>
    stashCreateRequest(requestId, {
      startingContext: stringifyStartingContext(toContextVariables(context)),
      transcript: transcriptForDraft(messages),
    });

  const path = simulationsListPath(slug, brainId);
  if (!path || isTrial) {
    return null;
  }

  return { href: createSimulationUrl(path, requestId), stash };
};
